import Vue from "vue";
import VueRouter from "vue-router";
import store from "@/store";
import Login from "../views/Login.vue";
import Dashboard from "../views/Dashboard.vue";
import Perfil from "../views/Perfil.vue";

Vue.use(VueRouter);

const routes = [
    {
        path: "/login",
        name: "login",
        component: Login,
        meta: {
            layout: "fullscreen",
        },
    },
    {
        path: "/",
        name: "Dashboard",
        component: Dashboard,
        meta: {
            layout: "menu",
            noSubheader: true,
        },
    },
    {
        path: "/meu-perfil",
        name: "Perfil",
        component: Perfil,
        meta: {
            layout: "menu",
            title: "Meu Perfil",
        },
    },
    {
        path: "/users",
        name: "Users",
        component: () => import("../views/Users.vue"),
        meta: {
            layout: "menu",
            title: "Usuários",
            noSubheader: true,
        },
    },
    {
        path: "/users/:id",
        component: () => import("../views/User.vue"),
        meta: {
            layout: "menu",
            title: "Usuário",
        },
    },
    {
        path: "/users/:userId/subscriptions/:id",
        component: () => import("../views/UserSubscription.vue"),
        meta: {
            layout: "menu",
            title: "Usuário",
        },
    },
    {
        path: "/forms",
        name: "FormList",
        component: () => import("../views/FormList.vue"),
        meta: {
            layout: "menu",
            title: "Lista de Formulários",
            noSubheader: true,
        },
    },
    {
        path: "/forms/:formId/elements",
        name: "FormElementList",
        component: () => import("../views/FormElementList.vue"),
        meta: {
            layout: "menu",
            title: "Lista de Elementos",
            noSubheader: true,
        },
    },
    {
        path: "/forms/:formId/categories",
        name: "FormCategoryList",
        component: () => import("../views/FormCategoryList.vue"),
        meta: {
            layout: "menu",
            title: "Lista de Categorias",
            noSubheader: true,
        },
    },
    {
        path: "/forms/:formId/categories/:categoryId",
        name: "FormCategoryDetail",
        component: () => import("../views/FormCategoryDetail.vue"),
        meta: {
            layout: "menu",
            title: "Detalhe da Categoria",
            noSubheader: true,
        },
    },
    {
        path: "/form-responses",
        component: () => import("../views/FormResponseList.vue"),
        meta: {
            title: "Criação de sites",
            layout: "menu",
            noSubheader: true,
        },
    },
    {
        path: "/form-responses/:formResponseId",
        name: "FormResponseSingle",
        component: () => import("../views/FormResponseSingle.vue"),
        meta: {
            permission: "DEFAULT",
            layout: "menu",
            title: "Formulário",
        },
    },
    {
        path: "/form-responses/:formResponseId/categories/:categoryId",
        name: "FormResponseSingleCategory",
        component: () => import("../views/FormResponseSingleCategory.vue"),
        meta: {
            permission: "DEFAULT",
            layout: "menu",
            title: "Formulário",
        },
    },
    {
        path: "/form-responses/:formResponseId/texts",
        name: "FormResponseTextList",
        component: () => import("../views/FormResponseTextList.vue"),
        meta: {
            permission: "DEFAULT",
            layout: "menu",
            title: "Formulário",
            noSubheader: true,
        },
    },
    {
        path: "/vindi/dashboard",
        name: "VindiDashboard",
        component: () => import("../views/vindi/VindiDashboard.vue"),
        meta: {
            layout: "menu",
            title: "Dashboard Vindi",
            noSubheader: true,
        },
    },
    {
        path: "/vindi/customers",
        name: "VindiCustomers",
        component: () => import("../views/vindi/VindiCustomers.vue"),
        meta: {
            layout: "menu",
            title: "Clientes Ativos Vindi",
            noSubheader: true,
        },
    },
    {
        path: "/vindi/plans",
        name: "VindiPlans",
        component: () => import("../views/vindi/VindiPlans.vue"),
        meta: {
            layout: "menu",
            title: "Planos de assinatura",
            noSubheader: true,
        },
    },
    {
        path: "/vindi/actions",
        name: "ActionsHistory",
        component: () => import("../views/vindi/ActionsHistory.vue"),
        meta: {
            layout: "menu",
            title: "Registro de ações",
            noSubheader: true,
        },
    },
    {
        path: "/vindi/subscriptions",
        name: "VindiSubscriptions",
        component: () => import("../views/vindi/VindiSubscriptions.vue"),
        meta: {
            layout: "menu",
            title: "Assinaturas Vindi",
            noSubheader: true,
        },
    },
    {
        path: "/vindi/products",
        name: "VindiProducts",
        component: () => import("../views/vindi/VindiProducts.vue"),
        meta: {
            layout: "menu",
            title: "Produtos Vindi",
            noSubheader: true,
        },
    },
    {
        path: "/assistants",
        name: "Assistente",
        component: () => import("../views/Assistants.vue"),
        meta: {
            layout: "menu",
            title: "Assistente de Secretárias",
        },
    },
    {
        path: "/articles",
        name: "Artigos",
        component: () => import("../views/ArtigosBeta.vue"),
        meta: {
            permission: "ARTICLE_ASSISTANT",
            layout: "menu",
            title: " ",
            noSubheader: true
        },
    },
    {
        path: "/articles/review/:id",
        name: "ArticleReview",
        component: () => import("../views/ArtigosReview.vue"),
        meta: {
            permission: "ARTICLE_ASSISTANT",
            layout: "menu",
            title: "Revisar artigo",
            noSubheader: true,
        },
    },
    {
        path: "/social-assistant",
        component: () => import("../views/SocialAssistant.vue"),
        meta: {
            layout: "menu",
            title: "Assistente Social",
            noSubheader: true
        },
    },
    {
        path: "/social-posts/:id",
        component: () => import("../views/SocialPost.vue"),
        meta: {
            layout: "menu",
            title: "Postagem Social",
            noSubheader: true
        },
    },
    {
        path: "/atendimentos",
        name: "ConversationDashboard",
        component: () => import("../views/conversation-analysis/ConversationDashboard.vue"),
        meta: {
            layout: "menu",
            title: "Análise de atendimentos",
            noSubheader: true,
            permission: "CONVERSATION_ANALYSIS",
        },
    },
    {
        path: "/atendimentos/conversas",
        name: "ConversationList",
        component: () => import("../views/conversation-analysis/ConversationList.vue"),
        meta: {
            layout: "menu",
            title: "Conversas",
            noSubheader: true,
            permission: "CONVERSATION_ANALYSIS",
        },
    },
    {
        path: "/atendimentos/conversas/nova",
        name: "ConversationCreate",
        component: () => import("../views/conversation-analysis/ConversationCreate.vue"),
        meta: {
            layout: "menu",
            title: "Nova conversa",
            noSubheader: true,
            permission: "CONVERSATION_ANALYSIS",
        },
    },
    {
        path: "/atendimentos/conversas/:id",
        name: "ConversationDetail",
        component: () => import("../views/conversation-analysis/ConversationDetail.vue"),
        meta: {
            layout: "menu",
            title: "Detalhe da conversa",
            noSubheader: true,
            permission: "CONVERSATION_ANALYSIS",
        },
    },
    {
        path: "/atendimentos/demandas",
        name: "ConversationDemands",
        component: () => import("../views/conversation-analysis/ConversationDemands.vue"),
        meta: {
            layout: "menu",
            title: "Demandas",
            noSubheader: true,
            permission: "CONVERSATION_ANALYSIS",
            adminOnly: true,
        },
    },
    {
        path: "/atendimentos/whatsapp",
        name: "ConversationWhatsapp",
        component: () => import("../views/conversation-analysis/ConversationWhatsapp.vue"),
        meta: {
            layout: "menu",
            title: "WhatsApp",
            noSubheader: true,
            permission: "CONVERSATION_ANALYSIS",
        },
    },
    {
        path: "/execucoes",
        name: "AsyncExecutions",
        component: () => import("../views/AsyncExecutions.vue"),
        meta: { layout: "menu", title: "Execuções", noSubheader: true, adminOnly: true },
    },
    {
        path: "/presenca-geo-seo",
        name: "GeoSeoPresence",
        component: () => import("../views/geo-seo/GeoSeoPresence.vue"),
        meta: { layout: "menu", title: "Presença GEO e SEO", noSubheader: true, permission: "GEO_SEO_PRESENCE" },
    },
    {
        path: "/perfil-no-google",
        name: "GoogleBusinessProfile",
        component: () => import("../views/google-business/GoogleBusinessDashboard.vue"),
        meta: {
            layout: "menu",
            title: "Perfil no Google",
            noSubheader: true,
        },
    },
    {
        path: "/:catchAll(.*)",
        name: "NotFound",
        component: () => import("../views/404.vue"),
        meta: {
            layout: "menu",
            title: "Página não encontrada",
            noSubheader: true,
        },
    }
];

const router = new VueRouter({
    mode: "history",
    base: process.env.BASE_URL,
    routes,
});

router.beforeEach(async (to, from, next) => {
    const publicPages = ["/login", "/password-recovery"];
    const authRequired = !publicPages.includes(to.path);
    const loggedIn = localStorage.getItem("token");

    if (authRequired && !loggedIn) {
        next({
            path: "/login",
            query: { redirect: to.fullPath, test: 123 },
        });
        return
    }

    if (to.meta.permission || to.meta.adminOnly) {
        let user = null
        if (['DEFAULT', 'ARTICLE_ASSISTANT', 'CONVERSATION_ANALYSIS', 'GEO_SEO_PRESENCE'].includes(to.meta.permission)) {
            try {
                await store.dispatch('loadCurrentUser')
                user = store.state.currentUser
            } catch { /* API authorization still enforces access. */ }
        }
        try {
            if (!user) user = JSON.parse(localStorage.getItem('user') || 'null')
        } catch { /* ignore */ }

        const isAdmin = user?.role === 'admin' || user?.admin
        const isPartner = user?.role === 'partner'
        const hasPermission = user?.permissions?.includes(to.meta.permission)
        if (to.meta.adminOnly && !isAdmin) return next(to.meta.permission ? '/atendimentos' : '/')
        if (to.meta.permission && !isAdmin && !isPartner && !hasPermission) return next('/')
    }

    next();
});

export default router;
